/**
 * Page is only accessible if user is authenticated.
 */

import AppApi from '@api/AppApi';
import { setupRoute } from '@utils/SetupUtil';

export default function({ to, from, store }) {
    // Get vars.
    let apiKey = store.getters.apiKey;
    let user = store.getters.user;
    let project = store.getters.project;

    // Not authenticated. Redirect to login page.
    if (to.name !== 'login' && !apiKey) {
        return { name: 'login', query: { redirect: to.fullPath } };
    }

    // Sub-accounts never use the wizard — agency projects are setup-complete.
    if (to.name === 'setup' && user?.is_sub_account) {
        return { name: 'dashboard' };
    }

    // No project, or first-project wizard not finished. Stay on project setup.
    if (to.name !== 'setup' && user && !user.is_sub_account && (!project || !project.setup_completed_at)) {
        return setupRoute({ from, to });
    }

    // No user. Boot app and redirect.
    if (!user) {
        return AppApi.getApp().then(() => {
            const bootedUser = store.getters.user;
            const bootedProject = store.getters.project;
            if (to.name === 'setup' && bootedUser?.is_sub_account) {
                return { name: 'dashboard' };
            }
            if (to.name !== 'setup' && !bootedUser?.is_sub_account && (!bootedProject || !bootedProject.setup_completed_at)) {
                return setupRoute({ from, to });
            }
            return to;
        }, (error) => {
            console.error('Error booting the app:', error);
            // This should not fail, but redirect to login if it does.
            store.commit('logout');
            return { name: 'login' };
        });
    }
}
